import React, { useState, useMemo, useEffect } from 'react';
import {
    CircleChevronLeft,
    CircleChevronRight,
    Image,
    Utensils,
    BedDouble,
    Sparkles,
    X,
    Search,
    ChevronDown,
    Clock,
    Check,
    Users,
    BriefcaseBusiness,
    MapPin,
    ChevronUp,
    Car,
} from 'lucide-react';
export default function ItineraryDayCard({ day, handleChangeAddOn, packageData, removeActivity }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFull, setShowFull] = useState(false);
    const [itineraryImageIndex, setItineraryImageIndex] = useState(0);
    const parsedDescription = useMemo(
        () => (day.description ? { __html: day.description } : ''),
        [day.description]
    );
    const MAX_CHARS = 180;
    const shortHTML = {
        __html:
            parsedDescription.__html.length > MAX_CHARS
                ? parsedDescription.__html.slice(0, MAX_CHARS) + '...'
                : parsedDescription.__html,
    };
    const [showHotelPopup, setShowHotelPopup] = useState(false);

    const [showFullDescription, setShowFullDescription] = useState(false);
    const [showFullDescriptionSigh, setShowFullDescriptionSigh] = useState(false);

    return (
        <>
            <div key={day.id} className="relative pl-12">

                <div className="absolute left-0 top-0 w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold z-10 border-4 border-white shadow-sm">
                    {day.days}
                </div>
                <div className="bg-white p-5 rounded-xl border border-gray-100 shadow-sm">
                    {/* <h3 className="font-bold text-lg text-blue-900 mb-3">Day {day.days}: {day.title}</h3> */}
                    <div className="flex justify-between items-start mb-1">
                        <h3 className="font-bold text-lg text-blue-900 mb-3">Day {day.days}: {day.title}</h3>

                        {day?.selectedHotel?.hotel_id > 0 && day.all_hotel_options.length > 0 && (
                            <div className="flex items-center bg-green-50 text-green-700 px-2.5 py-1 rounded-md" title={day.selectedHotel.hotel_name}>
                                <BedDouble className="w-[20px] h-[20px] mr-1.5" />
                                <span className="text-lg font-medium truncate max-w-[120px]">{day.selectedHotel.hotel_name}</span>
                                {day.all_hotel_options.length > 1 && <button
                                    onClick={() => setShowHotelPopup(true)}
                                    className="ml-2 text-sky-500 hover:text-sky-600 uppercase transition text-xs font-bold"
                                >
                                    CHANGE
                                </button>}
                            </div>
                        )}
                    </div>
                    <div className="mb-2">
                        <div
                            className="text-gray-700 text-sm"
                            dangerouslySetInnerHTML={showFull ? parsedDescription : shortHTML}
                        />
                        {parsedDescription.__html.length > MAX_CHARS && (
                            <button
                                onClick={() => setShowFull(!showFull)}
                                className="mt-0.5 text-blue-600 text-xs hover:underline"
                            >
                                {showFull ? 'See less' : 'See more'}
                            </button>
                        )}
                    </div>
                    {day.selectedcabs && Object.keys(day.selectedcabs).length > 0 && (
                        [day.selectedcabs].map((item, key) => {
                            return (
                                <div key={key} className="w-full max-w-4xl bg-white border-t pt-3 border-gray-200 font-sans mb-2">
                                    {/* Top Header Row */}
                                    <div className="flex items-center justify-between pb-4">
                                        {/* Left Section: Icon, Title, Duration, Location */}
                                        <div className="flex items-center space-x-2">
                                            {/* Active indicator bar */}
                                            <div className="h-6 w-1 bg-black rounded-full" />
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 12" fill="none" className="car-icon-no-commute"><path fillRule="evenodd" clipRule="evenodd" d="M15.8864 3.41705H17.3999C17.649 3.41705 17.8408 3.64145 17.8209 3.88505V4.43345C17.8209 4.69745 17.6303 4.90025 17.3812 4.90025H16.4606C16.6525 5.57225 16.7671 6.34505 16.7671 7.24025V8.80505V11.4511C16.7671 11.7151 16.5752 11.9191 16.3261 11.9191H14.6981C14.4489 11.9191 14.2571 11.7151 14.2571 11.4511V10.2307C12.7237 10.3723 11.0184 10.4539 9.21722 10.4539C7.41602 10.4539 5.70948 10.3723 4.17734 10.2307V11.4511C4.17734 11.7151 3.98551 11.9191 3.73638 11.9191H2.10708C1.85795 11.9191 1.66612 11.7151 1.66612 11.4511V7.24145C1.66612 6.34505 1.78072 5.57345 1.97255 4.90145H1.05326C0.804134 4.90145 0.612305 4.69745 0.612305 4.43345V3.88505C0.612305 3.62105 0.804134 3.41705 1.05326 3.41705H2.54804C2.59548 3.34642 2.63805 3.27078 2.68057 3.19524L2.68057 3.19524L2.68058 3.19523C2.72401 3.11807 2.76738 3.04101 2.81585 2.96945C2.89308 2.84705 3.92821 1.40345 4.36917 0.813055C4.77027 0.285055 5.28846 0.0810547 5.86394 0.0810547H12.5705C13.146 0.0810547 13.6816 0.304255 14.0653 0.813055C14.5249 1.40345 15.1191 2.21705 15.4056 2.64425C15.4454 2.69626 15.4803 2.75401 15.5152 2.81174L15.5152 2.81176L15.5152 2.81179C15.5479 2.86595 15.5806 2.92009 15.6173 2.96945C15.688 3.07376 15.7485 3.17872 15.8138 3.292L15.8138 3.29204L15.8139 3.29206C15.8372 3.33254 15.8612 3.37409 15.8864 3.41705ZM6.05457 6.89536L6.51421 6.24496L6.51297 6.24376C6.62881 6.08176 6.57151 5.95936 6.39837 5.97976H2.98779C2.81465 5.97976 2.64275 6.12136 2.62282 6.32536L2.58545 6.83416C2.58545 7.01776 2.71873 7.17976 2.91056 7.17976H5.51894C5.70953 7.17976 5.93997 7.05856 6.05457 6.89536ZM7.89414 4.27209H3.94544C3.71624 4.27209 3.52441 4.06809 3.52441 3.82449C3.52441 3.71214 3.60521 3.58363 3.64835 3.51502L3.65894 3.49809C3.75486 3.33609 4.69283 2.03409 5.01919 1.60689C5.32686 1.20009 5.74789 1.03809 6.18885 1.03809H8.12333V1.11849C8.12333 1.38249 8.31516 1.58649 8.56429 1.58649H9.92454C10.1737 1.58649 10.3655 1.38249 10.3655 1.11849V1.03809H12.3212C12.7621 1.03809 13.1831 1.20009 13.4896 1.60689C13.8159 2.03409 14.2569 2.64489 14.4861 2.97009C14.506 2.99049 14.5247 3.01089 14.5247 3.03009C14.5502 3.06843 14.5772 3.10805 14.6048 3.1486L14.6048 3.14863C14.6808 3.26038 14.7617 3.37923 14.8311 3.49809L14.8388 3.51015C14.8811 3.57659 14.9657 3.70954 14.9657 3.82449C14.9657 4.06809 14.7738 4.27209 14.5446 4.27209H7.89414ZM12.8969 7.15888H15.5214H15.5227C15.7133 7.15888 15.8665 6.99688 15.8465 6.79288L15.8092 6.28408C15.7905 6.08128 15.6373 5.93848 15.4454 5.93848H12.0336C11.8418 5.93848 11.7845 6.06088 11.8991 6.22408L12.36 6.87448C12.4746 7.03768 12.705 7.15888 12.8969 7.15888Z" fill="#4a4a4a"></path></svg>
                                            <span className="font-bold text-gray-800 text-sm tracking-wide">
                                                TRANSFER
                                            </span>
                                            <span className="text-gray-400 text-xs">•</span>
                                            <span className="text-gray-600 text-sm font-medium">
                                                {item?.name}
                                            </span>
                                            <span className="text-gray-400 text-xs">•</span>
                                            <span className="text-gray-600 text-sm font-medium">
                                                In {packageData?.package?.des_city_name || ''}
                                            </span>
                                            <button className="text-gray-600 hover:text-black ml-1 transition">
                                                <ChevronUp className="w-4 h-4" />
                                            </button>
                                        </div>
                                        {/* Right Section: Actions */}
                                        <div className="flex items-center space-x-3 text-xs font-bold tracking-wider">
                                            <button onClick={() => removeActivity(item, day, day.days, 'TRANSFERS')} className="text-sky-500 hover:text-sky-600 uppercase transition">
                                                Remove
                                            </button>
                                            <div className="h-3 w-px bg-gray-300" />
                                            <button onClick={() => handleChangeAddOn(item, day, day.days, 'TRANSFERS')} className="text-sky-500 hover:text-sky-600 uppercase transition">
                                                MODIFY
                                            </button>
                                        </div>
                                    </div>

                                    {/* Main Content Body */}
                                    <div className="flex flex-col md:flex-row gap-5 items-start mt-1">
                                        {/* Image */}
                                        <div className="w-full md:w-[220px] h-[150px] shrink-0 overflow-hidden rounded-md border p-4">
                                            <img
                                                src={item?.vehicle?.image || "/placeholder.png"}
                                                onError={(e) => {
                                                    e.target.onerror = null; // prevent infinite loop
                                                    e.target.src = "/placeholder.png"; // path to your placeholder image
                                                }}
                                                alt={item?.name}
                                                className="w-full h-full object-cover"
                                            />
                                        </div>

                                        {/* Description & Details */}
                                        <div className="flex flex-col justify-between flex-1">
                                            <div>
                                                <h2 className="text-md font-bold text-gray-950 leading-tight">
                                                    {item?.booking_basis} ({item?.vehicle?.name})
                                                </h2>

                                                <div className="mt-2 text-sm text-gray-600 leading-relaxed">
                                                    <span
                                                        dangerouslySetInnerHTML={{
                                                            __html: showFullDescription
                                                                ? item?.Summary || ""
                                                                : `${item?.Summary?.slice(0, 60) || ""}${item?.Summary?.length > 60 ? "..." : ""
                                                                }`,
                                                        }}
                                                    />

                                                    {item?.Summary?.length > 60 && (
                                                        <button
                                                            type="button"
                                                            onClick={() => setShowFullDescription(!showFullDescription)}
                                                            className="text-sky-500 font-semibold hover:underline ml-1 inline"
                                                        >
                                                            {showFullDescription ? "Read Less" : "Read More..."}
                                                        </button>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Metadata Highlights */}
                                            <div className="mt-1 space-y-1">
                                                <div className="flex items-center space-x-2 text-sm text-gray-600">
                                                    <MapPin className="w-4 h-4 text-gray-500 shrink-0" />
                                                    <span> {item?.name}</span>
                                                    <span className="text-gray-400 text-xs">•</span>
                                                    <span className='flex items-center gap-2'> <Users className="w-4 h-4 text-gray-500 shrink-0" />Max Pax {item.max_pax_capacity} </span>
                                                    <span className='flex items-center gap-2'> <BriefcaseBusiness className="w-4 h-4 text-gray-500 shrink-0" />Max Luggage {item.max_luggage_capacity} </span>
                                                </div>
                                                {item?.booking_included && (
                                                    <div className="flex items-center space-x-2 text-sm text-gray-600">
                                                        <Car className="w-4 h-4 text-gray-500 shrink-0" />
                                                        <span> {item?.booking_included} </span>
                                                    </div>
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    )}
                    {day.activity.length > 0 && (
                        day.activity.map((item, key) => {
                            return (
                                <div key={key} className="w-full max-w-4xl bg-white border-t pt-3 border-gray-200 font-sans mb-2">
                                    {/* Top Header Row */}
                                    <div className="flex items-center justify-between pb-4">
                                        {/* Left Section: Icon, Title, Duration, Location */}
                                        <div className="flex items-center space-x-2">
                                            {/* Active indicator bar */}
                                            <div className="h-6 w-1 bg-black rounded-full" />
                                            <svg width="20" height="20" viewBox="0 0 14 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M5.15177 3.89062C6.22126 3.89062 7.08826 3.01969 7.08827 1.94533C7.08827 1.4294 6.88425 0.934595 6.52109 0.569775C6.15792 0.204954 5.66537 0 5.15177 0C4.63818 0 4.14563 0.204954 3.78246 0.569775C3.4193 0.934595 3.21528 1.4294 3.21528 1.94533C3.21529 3.01969 4.08229 3.89062 5.15177 3.89062ZM2.6599 3.43913V4.41178H1.04953V3.43913H2.6599ZM7.1901 5.26891C6.80543 5.02746 6.35966 4.89842 5.90603 4.89842L4.80348 4.89614C3.99575 4.89614 3.35109 5.544 3.35111 6.35511L3.32846 13.9178L0.979701 21.0039L3.63672 20.6962L6.11595 15.111L7.49268 16.3212L6.77027 20.3314L8.99422 20.0711L9.90005 16.2546C10.0126 15.7799 9.88266 15.2806 9.5521 14.923L7.62695 12.8409C7.2113 12.3912 6.98019 11.7997 6.98019 11.1862C6.97949 10.1438 6.98735 9.31455 6.99585 8.41844V8.41842V8.41841V8.41839V8.41836C7.00029 7.95026 7.0049 7.46392 7.00855 6.91945L9.93598 8.54554H13.5159C13.7889 8.54554 14 8.33342 14 8.05917V7.81618C14 7.54197 13.7889 7.32985 13.5159 7.32985H10.6111C10.5208 7.32985 10.4324 7.30375 10.3558 7.25596L7.1901 5.26891ZM0.211806 7.23025L1.21031 5.38374H2.66268V13.6513H0.968247C0.433484 13.6513 0 13.2159 0 12.6787V7.9749C0 7.71161 0.072861 7.4534 0.211806 7.23025ZM12.573 9.51841V19.604L13.5413 19.4919V9.51833L12.573 9.51841ZM13.5413 6.3527V5.38006H12.573V6.3527H13.5413Z" fill="#4A4A4A"></path></svg>
                                            <span className="font-bold text-gray-800 text-sm tracking-wide">
                                                ACTIVITY
                                            </span>
                                            <span className="text-gray-400 text-xs">•</span>
                                            <span className="text-gray-600 text-sm font-medium">
                                                {item?.activity?.duration}
                                            </span>
                                            <span className="text-gray-400 text-xs">•</span>
                                            <span className="text-gray-600 text-sm font-medium">
                                                In {item?.activity?.city?.cityName}
                                            </span>
                                            <button className="text-gray-600 hover:text-black ml-1 transition">
                                                <ChevronUp className="w-4 h-4" />
                                            </button>
                                        </div>
                                        {/* Right Section: Actions */}
                                        <div className="flex items-center space-x-3 text-xs font-bold tracking-wider">
                                            <button onClick={() => removeActivity(item, day, day.days, 'ACTIVITY', key)} className="text-sky-500 hover:text-sky-600 uppercase transition">
                                                Remove
                                            </button>
                                            <div className="h-3 w-px bg-gray-300" />
                                            <button onClick={() => handleChangeAddOn(item, day, day.days, 'ACTIVITY', key)} className="text-sky-500 hover:text-sky-600 uppercase transition">
                                                MODIFY
                                            </button>
                                        </div>
                                    </div>

                                    {/* Main Content Body */}
                                    <div className="flex flex-col md:flex-row gap-5 items-start mt-1">
                                        {/* Image */}
                                        <div className="w-full md:w-[220px] h-[150px] shrink-0 overflow-hidden rounded-md">
                                            <img
                                                src={item?.activity?.images?.[0]?.image || "/placeholder.png"}
                                                onError={(e) => {
                                                    e.target.onerror = null; // prevent infinite loop
                                                    e.target.src = "/placeholder.png"; // path to your placeholder image
                                                }}
                                                alt={item?.activity?.images?.[0]?.alt_text}
                                                className="w-full h-full object-cover"
                                            />
                                        </div>

                                        {/* Description & Details */}
                                        <div className="flex flex-col justify-between flex-1">
                                            <div>
                                                <h2 className="text-md font-bold text-gray-950 leading-tight">
                                                    {item?.activity?.activity_name} ({item?.activity?.activity_type?.name})
                                                </h2>

                                                <p className="mt-2 text-sm text-gray-600 leading-relaxed">
                                                    {showFullDescription
                                                        ? item?.activity?.about_activity
                                                        : `${item?.activity?.about_activity?.slice(0, 180)}${item?.activity?.about_activity?.length > 500 ? "..." : ""
                                                        }`}

                                                    {item?.activity?.about_activity?.length > 180 && (
                                                        <button
                                                            type="button"
                                                            onClick={() => setShowFullDescription(!showFullDescription)}
                                                            className="text-sky-500 font-semibold hover:underline ml-1 inline"
                                                        >
                                                            {showFullDescription ? "Read Less" : "Read More..."}
                                                        </button>
                                                    )}
                                                </p>
                                            </div>

                                            {/* Metadata Highlights */}
                                            <div className="mt-1 space-y-1">
                                                <div className="flex items-center space-x-2 text-sm text-gray-600">
                                                    <Clock className="w-4 h-4 text-gray-500 shrink-0" />
                                                    <span>Duration: {item?.activity?.duration}</span>
                                                    {/* <span className="text-gray-400 text-xs">•</span>
                                                    <span>Morning</span> */}
                                                </div>
                                                {item?.price?.booking_included && (
                                                    <div className="flex items-center space-x-2 text-sm text-gray-600">
                                                        <Car className="w-4 h-4 text-gray-500 shrink-0" />
                                                        <span> {item?.price?.booking_included} </span>
                                                    </div>
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    )}
                    {day.sightseeings.length > 0 && (
                        day.sightseeings.map((item, key) => {
                            return (
                                <div key={key} className="w-full max-w-4xl bg-white border-t pt-3 border-gray-200 font-sans mb-2">
                                    {/* Top Header Row */}
                                    <div className="flex items-center justify-between pb-4">
                                        {/* Left Section: Icon, Title, Duration, Location */}
                                        <div className="flex items-center space-x-2">
                                            {/* Active indicator bar */}
                                            <div className="h-6 w-1 bg-black rounded-full" />
                                            <svg width="20" height="20" viewBox="0 0 14 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M5.15177 3.89062C6.22126 3.89062 7.08826 3.01969 7.08827 1.94533C7.08827 1.4294 6.88425 0.934595 6.52109 0.569775C6.15792 0.204954 5.66537 0 5.15177 0C4.63818 0 4.14563 0.204954 3.78246 0.569775C3.4193 0.934595 3.21528 1.4294 3.21528 1.94533C3.21529 3.01969 4.08229 3.89062 5.15177 3.89062ZM2.6599 3.43913V4.41178H1.04953V3.43913H2.6599ZM7.1901 5.26891C6.80543 5.02746 6.35966 4.89842 5.90603 4.89842L4.80348 4.89614C3.99575 4.89614 3.35109 5.544 3.35111 6.35511L3.32846 13.9178L0.979701 21.0039L3.63672 20.6962L6.11595 15.111L7.49268 16.3212L6.77027 20.3314L8.99422 20.0711L9.90005 16.2546C10.0126 15.7799 9.88266 15.2806 9.5521 14.923L7.62695 12.8409C7.2113 12.3912 6.98019 11.7997 6.98019 11.1862C6.97949 10.1438 6.98735 9.31455 6.99585 8.41844V8.41842V8.41841V8.41839V8.41836C7.00029 7.95026 7.0049 7.46392 7.00855 6.91945L9.93598 8.54554H13.5159C13.7889 8.54554 14 8.33342 14 8.05917V7.81618C14 7.54197 13.7889 7.32985 13.5159 7.32985H10.6111C10.5208 7.32985 10.4324 7.30375 10.3558 7.25596L7.1901 5.26891ZM0.211806 7.23025L1.21031 5.38374H2.66268V13.6513H0.968247C0.433484 13.6513 0 13.2159 0 12.6787V7.9749C0 7.71161 0.072861 7.4534 0.211806 7.23025ZM12.573 9.51841V19.604L13.5413 19.4919V9.51833L12.573 9.51841ZM13.5413 6.3527V5.38006H12.573V6.3527H13.5413Z" fill="#4A4A4A"></path></svg>
                                            <span className="font-bold text-gray-800 text-sm tracking-wide">
                                                SIGHTSEEING
                                            </span>
                                            <span className="text-gray-400 text-xs">•</span>
                                            <span className="text-gray-600 text-sm font-medium">
                                                {item?.sightseeing?.duration}
                                            </span>
                                            <span className="text-gray-400 text-xs">•</span>
                                            <span className="text-gray-600 text-sm font-medium">
                                                In {item?.sightseeing?.city?.cityName}
                                            </span>
                                            <button className="text-gray-600 hover:text-black ml-1 transition">
                                                <ChevronUp className="w-4 h-4" />
                                            </button>
                                        </div>
                                        {/* Right Section: Actions */}
                                        <div className="flex items-center space-x-3 text-xs font-bold tracking-wider">
                                            <button onClick={() => removeActivity(item, day, day.days, 'SIGHTSEEING', key)} className="text-sky-500 hover:text-sky-600 uppercase transition">
                                                Remove
                                            </button>
                                            <div className="h-3 w-px bg-gray-300" />
                                            <button onClick={() => handleChangeAddOn(item, day, day.days, 'SIGHTSEEING', key)} className="text-sky-500 hover:text-sky-600 uppercase transition">
                                                MODIFY
                                            </button>
                                        </div>
                                    </div>

                                    {/* Main Content Body */}
                                    <div className="flex flex-col md:flex-row gap-5 items-start mt-1">
                                        {/* Image */}
                                        <div className="w-full md:w-[220px] h-[150px] shrink-0 overflow-hidden rounded-md">
                                            <img
                                                src={item?.sightseeing?.images || "/placeholder.png"}
                                                onError={(e) => {
                                                    e.target.onerror = null; // prevent infinite loop
                                                    e.target.src = "/placeholder.png"; // path to your placeholder image
                                                }}
                                                alt={item?.sightseeing?.name}
                                                className="w-full h-full object-cover"
                                            />
                                        </div>

                                        {/* Description & Details */}
                                        <div className="flex flex-col justify-between flex-1">
                                            <div>
                                                <h2 className="text-md font-bold text-gray-950 leading-tight">
                                                    {item?.sightseeing?.name} ({item?.sightseeing?.sightseeing_type?.name})
                                                </h2>

                                                <p className="mt-2 text-sm text-gray-600 leading-relaxed">
                                                    {showFullDescriptionSigh
                                                        ? item?.sightseeing?.description
                                                        : `${item?.sightseeing?.description?.slice(0, 180)}${item?.sightseeing?.description?.length > 500 ? "..." : ""
                                                        }`}

                                                    {item?.sightseeing?.description?.length > 180 && (
                                                        <button
                                                            type="button"
                                                            onClick={() => setShowFullDescriptionSigh(!showFullDescriptionSigh)}
                                                            className="text-sky-500 font-semibold hover:underline ml-1 inline"
                                                        >
                                                            {showFullDescriptionSigh ? "Read Less" : "Read More..."}
                                                        </button>
                                                    )}
                                                </p>
                                            </div>

                                            {/* Metadata Highlights */}
                                            <div className="mt-1 space-y-1">
                                                <div className="flex items-center space-x-2 text-sm text-gray-600">
                                                    <Clock className="w-4 h-4 text-gray-500 shrink-0" />
                                                    <span>Duration: {item?.sightseeing?.duration}</span>
                                                    {/* <span className="text-gray-400 text-xs">•</span>
                                                    <span>Morning</span> */}
                                                </div>
                                                {item?.price?.booking_included && (
                                                    <div className="flex items-center space-x-2 text-sm text-gray-600">
                                                        <Car className="w-4 h-4 text-gray-500 shrink-0" />
                                                        <span> {item?.price?.booking_included}</span>
                                                    </div>
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    )}

                    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-4 rounded-xl bg-[#f0f7ff] p-3 sm:p-3">
                        <div className="flex items-center gap-3 sm:gap-4">
                            <div className="flex h-10 w-10 sm:h-12 sm:w-12 shrink-0 items-center justify-center rounded-full bg-white shadow-xs">
                                <Sparkles className="h-5 w-5 sm:h-6 sm:w-6 text-blue-500" strokeWidth={1.75} />
                            </div>

                            <div className="flex flex-col">
                                <h3 className="text-sm sm:text-base font-bold text-gray-900 sm:text-md">
                                    Add Activities/Sightseeing/Transfer to your day
                                </h3>
                                <div className="text-xs sm:text-sm text-gray-600">
                                    Spend the day at leisure or add an activity, Sightseeing, transfer to your day
                                </div>
                            </div>
                        </div>
                        <button
                            type="button"
                            className="shrink-0 self-start sm:self-auto text-sm font-bold tracking-wide text-blue-600 transition-colors hover:text-blue-700 uppercase cursor-pointer pl-13 sm:pl-0"
                            onClick={() => handleChangeAddOn([], day, day.days, 'ACTIVITY', 0)}
                        >
                            ADD TO DAY
                        </button>
                    </div>
                    {(day.breakfast === 1 || day.lunch === 1 || day.dinner === 1) && (
                        <div className="mt-2 pt-2 border-t border-gray-200">
                            <div className="flex items-center gap-2">
                                <Utensils className="w-4 h-4 text-green-600" />
                                <span className="text-xs font-medium text-gray-700 mr-2">Meals:</span>
                                {day.breakfast === 1 && (
                                    <span className="inline-flex items-center px-2 py-0.5 bg-green-100 text-green-800 rounded text-xs">
                                        Breakfast
                                    </span>
                                )}
                                {day.lunch === 1 && (
                                    <span className="inline-flex items-center px-2 py-0.5 bg-yellow-100 text-yellow-800 rounded text-xs">
                                        Lunch
                                    </span>
                                )}
                                {day.dinner === 1 && (
                                    <span className="inline-flex items-center px-2 py-0.5 bg-red-100 text-red-800 rounded text-xs">
                                        Dinner
                                    </span>
                                )}
                            </div>
                        </div>
                    )}

                    {day.images && day.images.length > 0 && (
                        <div className="mt-2 pt-2 border-t border-gray-200">
                            <div className="flex items-center justify-between mb-2">
                                <div className="flex items-center">
                                    <Image className="w-4 h-4 text-purple-600 mr-1.5" />
                                    <span className="text-xs font-medium text-gray-700">Images</span>
                                </div>
                                <span className="text-xs text-gray-500">
                                    {itineraryImageIndex + 1}/{day.images.length}
                                </span>
                            </div>

                            {/* Removed fixed h-48; container now sizes to the image's own aspect ratio */}
                            <div className="relative w-full rounded-lg overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100">
                                <img
                                    src={day.images[itineraryImageIndex] || "/elementor-placeholder-image.png"}
                                    alt={`Day ${day.days}`}
                                    className="w-full h-auto max-h-64 object-contain mx-auto"
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = '/elementor-placeholder-image.png';
                                    }}
                                />

                                {day.images.length > 1 && (
                                    <>
                                        <button
                                            onClick={() => setItineraryImageIndex(prev =>
                                                prev === 0 ? day.images.length - 1 : prev - 1
                                            )}
                                            className="absolute left-1 top-1/2 transform -translate-y-1/2 bg-white/90 hover:bg-white p-1 rounded-full shadow"
                                        >
                                            <CircleChevronLeft className="w-4 h-4 text-gray-700" />
                                        </button>
                                        <button
                                            onClick={() => setItineraryImageIndex(prev =>
                                                prev === day.images.length - 1 ? 0 : prev + 1
                                            )}
                                            className="absolute right-1 top-1/2 transform -translate-y-1/2 bg-white/90 hover:bg-white p-1 rounded-full shadow"
                                        >
                                            <CircleChevronRight className="w-4 h-4 text-gray-700" />
                                        </button>
                                    </>
                                )}

                                {day.images.length > 1 && (
                                    <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-1">
                                        {day.images.map((_, index) => (
                                            <button
                                                key={index}
                                                onClick={() => setItineraryImageIndex(index)}
                                                className={`w-1.5 h-1.5 rounded-full ${index === itineraryImageIndex
                                                    ? 'w-4 bg-white'
                                                    : 'bg-white/60'}`}
                                            />
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    {/* {day.images && day.images.length > 0 && (
                        <div className="mt-2 pt-2 border-t border-gray-200">
                            <div className="flex items-center justify-between mb-2">
                                <div className="flex items-center">
                                    <Image className="w-4 h-4 text-purple-600 mr-1.5" />
                                    <span className="text-xs font-medium text-gray-700">Images</span>
                                </div>
                                <span className="text-xs text-gray-500">
                                    {itineraryImageIndex + 1}/{day.images.length}
                                </span>
                            </div>

                            <div className="relative h-48 rounded-lg overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100">
                                <img
                                    src={day.images[itineraryImageIndex]}
                                    alt={`Day ${day.days}`}
                                    className="w-full h-full object-cover"
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = '/images/hotel_placeholder.png';
                                    }}
                                />

                                {day.images.length > 1 && (
                                    <>
                                        <button
                                            onClick={() => setItineraryImageIndex(prev =>
                                                prev === 0 ? day.images.length - 1 : prev - 1
                                            )}
                                            className="absolute left-1 top-1/2 transform -translate-y-1/2 bg-white/90 hover:bg-white p-1 rounded-full shadow"
                                        >
                                            <CircleChevronLeft className="w-4 h-4 text-gray-700" />
                                        </button>
                                        <button
                                            onClick={() => setItineraryImageIndex(prev =>
                                                prev === day.images.length - 1 ? 0 : prev + 1
                                            )}
                                            className="absolute right-1 top-1/2 transform -translate-y-1/2 bg-white/90 hover:bg-white p-1 rounded-full shadow"
                                        >
                                            <CircleChevronRight className="w-4 h-4 text-gray-700" />
                                        </button>
                                    </>
                                )}

                                {day.images.length > 1 && (
                                    <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-1">
                                        {day.images.map((_, index) => (
                                            <button
                                                key={index}
                                                onClick={() => setItineraryImageIndex(index)}
                                                className={`w-1.5 h-1.5 rounded-full ${index === itineraryImageIndex
                                                    ? 'w-4 bg-white'
                                                    : 'bg-white/60'}`}
                                            />
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    )} */}
                </div>
            </div>
        </>
    )
}